/**
 * WP15 — jeden wspólny helper bazy API + nagłówków auth.
 * Ujednolica rozjazd: część klienta wołała względne /api, część absolutne
 * VITE_API_URL. Teraz wszyscy używają tej samej reguły (kontrakt bez zmian).
 */
import { SaveLocal } from './SaveLocal.js';

/**
 * Baza URL API. Puste = ścieżki względne (`/api/...`) — dev + same-origin prod.
 * Ustawione `VITE_API_URL` = absolutny origin serwera (np. cross-origin PWA).
 */
export function apiBase(): string {
  try {
    const v = (import.meta as unknown as { env?: { VITE_API_URL?: string } }).env
      ?.VITE_API_URL;
    if (typeof v === 'string' && v.length > 0) return v.replace(/\/$/, '');
  } catch {
    /* brak import.meta w części środowisk testowych */
  }
  return '';
}

/** Nagłówki JSON + Bearer (jeśli mamy token). */
export function authHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  const token = SaveLocal.getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}
